export default __webpack_public_path__ + "static/media/a' sgrìobhadh.a1c188f7.mp3";